import React, { Fragment } from "react"

import { Field, useFormikContext } from "formik"
import { getInNested } from "../dynamic-form.helper"

function InputEmail(props) {
  const { id, label, name, value, placeholder, errorMessage, fieldData, isNestedFieldName, isRequired, ...otherProps } = props
  const { errors, touched } = useFormikContext()
  const normalizedNameKey = isNestedFieldName ? name : `['${name}']`
  return (
    <Fragment>
      <div className="form-block-wrapper">
        <div className="custom-form-block flex-grow-1">
          <label htmlFor={id} className="form-label">
            {label} {isRequired && <sup>*</sup>}
          </label>
          <div className="input-group custom-field has-validation">
            <Field
              type="email"
              id={id}
              className={`form-control ${
                getInNested(touched, name, isNestedFieldName) && getInNested(errors, name, isNestedFieldName) ? "is-invalid" : ""
              }`}
              name={normalizedNameKey}
              // value={value}
              placeholder={placeholder}
              {...otherProps}
            ></Field>
          </div>
          <div className="invalid-feedback">
            {getInNested(touched, name, isNestedFieldName) && getInNested(errors, name, isNestedFieldName) ? errorMessage : ""}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

InputEmail.propTypes = {}

export default InputEmail
